define('glu/grid/paginate/pageSizeControls',['require','../../itemView','../../locale','../../util','hbs!./pageSizeControls.hbs','../../inputPlugins'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        locale = require('../../locale'),
        util = require('../../util'),
        tmpl = require('hbs!./pageSizeControls.hbs');

    require('../../inputPlugins'); // flexDropdown helper

    return ItemView.extend({
        template: tmpl,

        ui: {
            $sizeSelect: '.paginate-page-size'
        },

        events: {
            'change @ui.$sizeSelect': 'handleSizeSelect'
        },

        templateHelpers: function() {
            return {
                cid: this.cid
            };
        },

        handleSizeSelect: function(e) {
            var vals = this.$(e.currentTarget).flexDropdown('val');
            this.options.pager.updatePageSizeValue(vals[0]);
        },

        onBeforeClose: function() {
            this.ui.$sizeSelect.flexDropdown('destroy');
        },
        onRender: function() {
            this.initDropDown();
        },

        initDropDown: function() {
            this.ui.$sizeSelect.flexDropdown({
                label: locale.get('display'),
                showTooltip: false,
                disableMultiButton: true,
                preSelectedIds: [this.options.data.pageSize],
                data: util.map(this.options.data.pageSizeList, function(pageSize) {
                    return {
                        id: pageSize,
                        name: pageSize
                    };
                })
            });
        }
    });
});

